// Ported from the Aptos reference app (apps/web/src/lib/embeddedWebview.ts).
// Best-effort embedded-webview detection.
//
// Real rule (Google's OAuth policy, Apple's sign-in is the same): WKWebView
// / UIWebView / Android WebView get blocked for social login. Safari view
// controllers and Android Custom Tabs are fine. Instagram, Facebook, Line
// and WeChat all put a recognizable token in the UA; Telegram doesn't on
// iOS but injects detectable bridge objects instead. WhatsApp on iOS hands
// off to the system browser, so it's deliberately not listed.
export function isLikelyEmbeddedWebview(): boolean {
  if (typeof window === "undefined") return false;

  const w = window as unknown as {
    Telegram?: { WebApp?: unknown };
    TelegramWebviewProxy?: unknown;
    TelegramWebview?: unknown;
  };

  const isTelegram =
    !!w.Telegram?.WebApp ||
    !!w.TelegramWebviewProxy ||
    !!w.TelegramWebview ||
    /(Telegram-Android|Telegram\/|TDesktop|TWeb)/i.test(navigator.userAgent);

  const isOtherKnownEmbedded = /(Instagram|FBAN|FBAV|Line\/|MicroMessenger)/i.test(
    navigator.userAgent,
  );

  return isTelegram || isOtherKnownEmbedded;
}
